angular.module('CarsSaraBo').factory('CompanyService', ['$resource', function($resource) {
  return $resource('../rest/company/:oid/',
    { oid : '@oid' },
    {
    	update : { method: 'PUT' }
    }
  )}
]);


angular.module('CarsSaraBo').factory('CompanyServicePage', ['$resource', function ($resource) {
	return $resource('../rest/company/page',
		null,
		{
			queryPage: {method: 'GET', isArray: false}
		});
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/company_service.js
// module id = 842
// module chunks = 3